import { Observable } from "rxjs";
import { PreResRequest } from "./request/pre_res_request";
import { PreResResponse } from "./response/pre_res_response";

export abstract class PreResRepository{
    abstract listar( fd : PreResRequest):Observable<PreResResponse>;
}